module.exports = {
    "breadcrumbs": `Naviga\u{10D}n\xe9 prvky Breadcrumbs`
};


//# sourceMappingURL=sk-SK.main.js.map
